function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M175.86,374.84l-12.32,8A59.24,59.24,0,0,0,146,464.47L265.26,649.1a59.24,59.24,0,0,0,81.63,17.54l12.34-8A59.22,59.22,0,0,0,376.77,577L257.5,392.41A59.24,59.24,0,0,0,175.86,374.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M64.27,446.94l-12.33,8a59.23,59.23,0,0,0-17.55,81.64L153.67,721.17a59.22,59.22,0,0,0,81.66,17.54l12.29-7.94a59.19,59.19,0,0,0,17.55-81.64L145.89,464.49A59.2,59.2,0,0,0,64.27,446.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M534.86,531.38l-.79-438.84A67.72,67.72,0,0,0,466.55,25H452.33a67.71,67.71,0,0,0-67.5,67.54V344.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M287.37,302.81l-12.31,7.94a59.24,59.24,0,0,0-17.58,81.66l92.58,143.28a59.19,59.19,0,0,0,81.64,17.57l12.33-8a59.22,59.22,0,0,0,17.54-81.64L369,320.36A59.22,59.22,0,0,0,287.37,302.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M359.53,932.42C371.88,809.61,536,755,536,755l13.56-57.08L471.91,644c-30.5-24.73-34.28-66.44-14-102.78,15.93-28.43,48.88-17,48.88-17s145.5,35.69,177,56.38C751.26,625,701.71,794.23,674.3,846S569.67,1057.2,569.67,1057.2L552.86,1133"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "27.23 520.75 45.55 828.71 149.79 1057.18"
})));

function SvgRight1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 742.66 1157.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight1);
export default __webpack_public_path__ + "static/media/right-1.838041f5.svg";
export { ForwardRef as ReactComponent };